import React, { useState } from "react";
import "./Home.scss";
import Logo from "../../img/Logo.svg";
import Menu1 from "../../img/Menu-icons-Group-1.png";
import Menu2 from "../../img/Dessert-outline.png";
import Menu3 from "../../img/Menu-icons-Group-3.png";
import Menu4 from "../../img/Menu-icons-Group-4.png";
import insta from "../../img/Insta.png";

import ChooesACategory from "../../layout/homeCategory/ChooesACategory";
// import HomeCategory from '../../data/ChooesACategory.json'
import RestaurantData from "../../data/MainJson";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";

const Home = () => {
  const [CategoryData, setCategoryData] = useState(RestaurantData);

  return (
    <div id="HomePage">
      <div className="headerSections">
        <img loading="lazy" width={227} src={Logo} alt="Cjs" />
        <div className="welcome">Welcome To CJ's</div>
        <div className="chooseCategory">Choose a Category</div>
      </div>

      <div className="margin">
        <ChooesACategory data={CategoryData} />
      </div>


      <div className="TabsMenu">
        <div className="MenuItems">
          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Big On Breakfast`}
          >
            <div className="items">
              <img width={40} src={Menu4} alt="Menu1" />
            </div>
          </Link>

          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Generous Big Meals`}
          >
            <div className="items">
              <img width={30} src={Menu3} alt="Menu1" />
            </div>
          </Link>
          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Perfected Drinks`}
          >
            <div className="items">
              <img width={25} src={Menu1} alt="Menu1" />
            </div>
          </Link>
          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Decadent Dessert`}
          >
            <div className="items">
              <img width={30} src={Menu2} alt="Menu1" />
            </div>
          </Link>
        </div>
      </div>

      <a style={{textDecoration:"none"}} href="https://www.instagram.com/cjs254?igsh=MWtldXRrOXRvaThlMw==" rel="noreferrer" target="_blank" class="social-sidebar">
        <div class="social-text">

          <span style={{fontSize:"10px"}}>
          Let’s be social!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b style={{ fontSize: "12px", paddingLeft: "10px" }}>Follow or Tag us:</b>
          </span>
          <img src={insta} alt="insta"/>

        </div>
      </a>
    </div>
  );
};

export default Home;
